import ApiService from "../services/api";

export interface ContractResponse {
  smart_contratovolkstotalid?: string;
  smart_nrcontrato?: string;
  _smart_veiculo_value?: string;
}

export const fetchContractByVehicle = async (chassis: string): Promise<string | null> => {
  const apiService = new ApiService();

  try {
    const endpoint = `/dynamics/smart_contratovolkstotals?$filter=_smart_veiculo_value eq '${chassis}'&$select=smart_nrcontrato,smart_contratovolkstotalid,_smart_veiculo_value`;
    const response = await apiService.get<ContractResponse[]>(endpoint);

    if (response.status === 200 && response.data && response.data.length > 0) {
      return response.data[0].smart_nrcontrato || null;
    }

    return null;
  } catch (error: unknown) {
    console.error("Erro ao buscar contrato do veículo:", error);
    return null;
  }
};
